var map = {
	"./BrokenClouds.png": "7a36",
	"./ClearSky.png": "0f64",
	"./FewClouds.png": "e9dc",
	"./LightRain.png": "bf36",
	"./Mist.png": "f530",
	"./ScatteredClouds.png": "4ee9",
	"./ShowerRain.png": "571c",
	"./Snow.png": "9eeb",
	"./Thunderstorm.png": "0267"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6d62";